import type { FaireProductEntity } from "../../entity_types/product";

export const p_huqg9r9egd: FaireProductEntity = {
  token: "p_huqg9r9egd",
  type: "product",
  name: "All the Time Miss You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7c049ac9dba6ec564409ea6f581d050722bc0a55f17fc729f507fe9f586483f6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4097ae2ef6b6d10fa5e94b1f35093da7a43effe23cf697f1109ab6f688b3ef49.png",
    "https://cdn.faire.com/fastly/4a32488a91c0c08be2cb524ed3f66bc63c22243883b803fa06bd40208acb22f2.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:44.504Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
